import { List, Map } from "immutable";

import CourseExamQuestionsSpec from "seneca-common/features/assignments/state/models/spec/CourseExamQuestionsSpec";
import CourseSectionsSpec from "seneca-common/features/assignments/state/models/spec/CourseSectionsSpec";

export function getCourseId(
  spec: CourseSectionsSpec | CourseExamQuestionsSpec
) {
  return spec.courseId;
}

export function getSectionIds(spec: CourseSectionsSpec): List<string> {
  return spec.sectionContentIds && spec.sectionContentIds.size > 0
    ? spec.sectionContentIds.keySeq().toList()
    : spec.sectionIds;
}

export function getContentIds(spec: CourseSectionsSpec): List<string> {
  return (
    spec.sectionContentIds
      ?.valueSeq()
      .flatMap(ids => ids)
      .toList() ?? List()
  );
}

export function getContentIdsForSection(
  spec: CourseSectionsSpec,
  sectionId: string
): List<string> {
  return spec.sectionContentIds?.get(sectionId) ?? List();
}

export function getExamQuestionIds(
  spec: CourseSectionsSpec | CourseExamQuestionsSpec
): List<string> {
  return spec.questionIds;
}

export function getSectionContentIds(spec: CourseSectionsSpec) {
  const sectionContentIds: Map<string, List<string>> | undefined = spec?.get(
    "sectionContentIds",
    Map()
  );

  return sectionContentIds;
}
